"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDropzone = require("react-dropzone");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactRedux = require("react-redux");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _uploadProspectingContacts = require("../../constants/uploadProspectingContacts.constants");

var _providers = require("../../../../providers");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var _useTrackGiftingFlow = require("../../../../hooks/useTrackGiftingFlow");

var _fixedCacheKeys = require("../../../../constants/fixedCacheKeys");

var _createBatchStep = require("../../../../store/ui/createBatchStep");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    dropZone: {
      paddingLeft: spacing(18),
      paddingRight: spacing(18),
      paddingTop: spacing(1),
      paddingBottom: spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    selectFileButton: {
      color: palette.link.main,
      padding: 0,
      fontSize: 12,
      '&:hover': {
        background: 'transparent'
      }
    },
    sampleTemplateButton: {
      marginTop: spacing(1),
      paddingLeft: 0,
      paddingRight: 0,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    loader: {
      color: palette.link.main
    }
  };
});
var styles = {
  adviseMessage: {
    background: function background(_ref2) {
      var palette = _ref2.palette;
      return palette.green.fruitSaladLight;
    }
  }
};

var ImportDropZone = function ImportDropZone(_ref3) {
  var children = _ref3.children;
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex.campaignId;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isAccepted = _useState2[0],
      setIsAccepted = _useState2[1];

  var _useLazyGetProspectin = (0, _services.useLazyGetProspectingContactsFileTemplateQuery)(),
      _useLazyGetProspectin2 = (0, _slicedToArray2.default)(_useLazyGetProspectin, 1),
      downloadContactsFileTemplate = _useLazyGetProspectin2[0];

  var _useUploadProspecting = (0, _services.useUploadProspectingContactsFileMutation)({
    fixedCacheKey: _fixedCacheKeys.GIFTING_FLOW_CACHE_KEYS.UPLOAD_CONTACTS_FILE
  }),
      _useUploadProspecting2 = (0, _slicedToArray2.default)(_useUploadProspecting, 2),
      uploadProspectingContactsFile = _useUploadProspecting2[0],
      isLoading = _useUploadProspecting2[1].isLoading;

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var countriesNames = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    var _campaign$countryIds;

    return (0, _commonData.makeGetCountriesMapNamesByIds)((_campaign$countryIds = campaign === null || campaign === void 0 ? void 0 : campaign.countryIds) !== null && _campaign$countryIds !== void 0 ? _campaign$countryIds : []);
  }, [campaign]));
  var trackGiftingFlowDropImportFile = (0, _useTrackGiftingFlow.useGiftingFlowDropImportFile)();
  var trackGiftingFlowEnterContactsButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowEnterContactsButtonClicked)();
  var trackGiftingFlowDownloadXLSTemplateButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowDownloadXLSTemplateButtonClicked)();
  var onDropAccepted = (0, _react.useCallback)(function (acceptedFiles) {
    setIsAccepted(true);

    var _acceptedFiles = (0, _slicedToArray2.default)(acceptedFiles, 1),
        file = _acceptedFiles[0];

    if (!file) {
      return;
    }

    if (campaignId) {
      uploadProspectingContactsFile({
        campaignId,
        body: {
          contacts: file
        }
      }).unwrap().then(function () {
        dispatch((0, _createBatchStep.setCreateBatchStep)(_createBatchStep.CreateBatchStep.ContactsPreview));
      });
      trackGiftingFlowDropImportFile();
    }
  }, [dispatch, uploadProspectingContactsFile, setIsAccepted, campaignId, trackGiftingFlowDropImportFile]);
  var onDropRejected = (0, _react.useCallback)(function () {
    setIsAccepted(false);
  }, [setIsAccepted]);

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    noClick: true,
    noKeyboard: true,
    accept: _uploadProspectingContacts.BULK_UPLOAD_ACCEPT_MIME,
    maxSize: _uploadProspectingContacts.MAX_BULK_FILE_SIZE,
    onDropAccepted,
    onDropRejected
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      open = _useDropzone.open,
      isDragActive = _useDropzone.isDragActive;

  var onDownloadTemplateClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    downloadContactsFileTemplate();

    if (campaignId) {
      trackGiftingFlowDownloadXLSTemplateButtonClicked(campaignId);
    }
  }, [downloadContactsFileTemplate, trackGiftingFlowDownloadXLSTemplateButtonClicked, campaignId]);
  var handleAddSingleContact = (0, _react.useCallback)(function () {
    dispatch((0, _createBatchStep.setCreateBatchStep)(_createBatchStep.CreateBatchStep.ContactsPreview));

    if (campaignId) {
      trackGiftingFlowEnterContactsButtonClicked(campaignId);
    }
  }, [dispatch, trackGiftingFlowEnterContactsButtonClicked, campaignId]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    fontWeight: 600
  }, "Bulk Upload")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    m: 3,
    p: 2,
    sx: styles.adviseMessage
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Only add recipients for these countries: ", /*#__PURE__*/_react.default.createElement("b", null, countriesNames.join(', ')))), /*#__PURE__*/_react.default.createElement(_material.Box, getRootProps({
    className: (0, _classnames.default)(classes.dropZone)
  }), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    fullWidth: true,
    onClick: open,
    color: "secondary",
    variant: "contained",
    disabled: isLoading
  }, isDragActive ? 'Drop' : 'Select', " .XLSX File"), /*#__PURE__*/_react.default.createElement(_ui.Button, {
    disableRipple: true,
    variant: "text",
    onClick: onDownloadTemplateClick,
    className: classes.sampleTemplateButton,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "file-download",
      fontSize: 1
    })
  }, "Download .XLSX template")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block",
    width: 400,
    fontSize: 12,
    textAlign: "center"
  }, "You may upload up to 200 contacts at a time."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pt: 1,
    pb: 1,
    width: 400,
    fontSize: 16,
    fontWeight: 800,
    textAlign: "center"
  }, "or"), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    borderColor: "divider",
    onClick: handleAddSingleContact,
    "data-testid": "ProspectingCampaigns.BulkUpload.EnterContacts",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "pencil"
    })
  }, "Enter Contact(s)"))), !isAccepted && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "error"
  }, "You may upload up to 200 contacts at a time. Only *.xlsx lower than ", _uploadProspectingContacts.MAX_BULK_FILE_SIZE / 1024, "KiB will will be accepted"))), children);
};

var _default = /*#__PURE__*/(0, _react.memo)(ImportDropZone);

exports.default = _default;